import { createAction, handleActions } from 'redux-actions';
import _ from 'lodash';

//- Actions
export const fetchSubmitForm = createAction('FETCH_SUBMIT_FORM');
export const fetchSubmitFormFailed = createAction('FETCH_SUBMIT_FORM_FAILED');
export const fetchSubmitFormSuccess = createAction('FETCH_SUBMIT_FORM_SUCCESS');
export const resetSubmitFormData = createAction('RESET_SUBMIT_FORM_DATA');
export const resetSubmitForm = createAction('RESET_SUBMIT_FORM');
export const resetFieldErrors = createAction('RESET_FIELD_ERRORS');
export const setFieldErrors = createAction('SET_FIELD_ERRORS');

//- State
const initialState = {
    error: null,
    fetching: false,
    success: false,
    fieldsErrors: null
};

//- Reducers
export default handleActions({

    FETCH_SUBMIT_FORM: (state) => {
        return { ...state, error: null, fetching: true, success: false };
    },
    FETCH_SUBMIT_FORM_FAILED: (state, action) => {
       return { ...state, error: action.payload, fetching: false, success: false };
    },
    FETCH_SUBMIT_FORM_SUCCESS: (state) => {
        return { ...state, error: null, fetching: false, success: true };
    },
    RESET_SUBMIT_FORM_DATA: () => {
        return initialState;
    },
    RESET_SUBMIT_FORM: (state) => {
        return {...initialState, fieldsErrors: state.fieldsErrors};
    },
    RESET_FIELD_ERRORS: (state, action) => {
        let fieldsErrors = state.fieldsErrors;
        if (!_.isNil(fieldsErrors)) {
            fieldsErrors = fieldsErrors.length > 1 ? _.without(fieldsErrors, action.payload) : null;
        }

        return {...state, fieldsErrors};
    },
    SET_FIELD_ERRORS: (state, action) => {
        let fieldsErrors = !_.isNil(action.payload) && _.isPlainObject(action.payload) ? Object.keys(action.payload) : null;
        return { ...state, fieldsErrors: fieldsErrors };
    }

}, initialState);

//- Selectors
export const getSubmitForm = state => state.submitForm;

export const getSubmitFormSuccessStatus = state => getSubmitForm(state).success;

export const getSubmitFormError = state => getSubmitForm(state).error;

export const getSubmitFormFetchingStatus = state => getSubmitForm(state).fetching;

export const getSubmitFormFieldsErrors = state => getSubmitForm(state).fieldsErrors;


// WEBPACK FOOTER //
// ./src/reducers/common/submitForm.js